import React from 'react';
import { Box, Button } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { clientSx } from '../../theme';

/**
 * Fixed bottom save bar — same chrome as admin PersonaFormDialog page layout.
 */
const MyPatientsPageActionBar = ({ formId, label = 'Save', extra = null, saveDisabled = false }) => (
  <Box sx={clientSx.pageActionBar}>
    {extra}
    <Button
      type="submit"
      form={formId}
      variant="contained"
      startIcon={<SaveIcon />}
      disabled={saveDisabled}
      sx={{ minHeight: 44 }}
    >
      {label}
    </Button>
  </Box>
);

export default MyPatientsPageActionBar;
